import React, { useCallback, useEffect, useState } from "react"
import { Button } from "reactstrap"
import { useHistory } from "react-router-dom"

import { AiOutlineClose } from "react-icons/ai"
import { Modal, Box } from "@mui/material"
import { modalStyle } from "constants/layout"

import userStore from "userStore"
import useWindowsSize from "hooks/useWindowsSize"

const RouterPrompt = props => {
  const { when, onOK, onCancel, handleSubmit, setGoback, goback } = props

  const history = useHistory()
  const { isMobile } = useWindowsSize()

  const [showPrompt, setShowPrompt] = useState(false)
  const [currentPath, setCurrentPath] = useState("")

  const customStyles = { ...modalStyle, width: isMobile ? "90%" : 500 }

  useEffect(() => {
    if (when) {
      history.block(prompt => {
        setCurrentPath(prompt.pathname)
        setShowPrompt(true)
        return "true"
      })
    } else {
      history.block(() => {})
    }

    return () => {
      history.block(() => {})
    }
  }, [history, when])

  const handleSave = useCallback(
    async (e, save) => {
      if (onOK) {
        const canRoute = await Promise.resolve(onOK())
        if (canRoute) {
          if (goback) {
            history.goBack()
          } else {
            history.block(() => {})
            history.push(currentPath)
          }
          userStore.setState({ changes: false })
          if (save) {
            handleSubmit(e)
          }
        }
      }
    },
    [currentPath, history, onOK],
  )

  const handleCancel = useCallback(async () => {
    if (onCancel) {
      const canRoute = await Promise.resolve(onCancel())
      setGoback(false)
      if (canRoute) {
        history.block(() => {})
        history.push(currentPath)
      }
    }
    setShowPrompt(false)
  }, [currentPath, history, onCancel])

  return showPrompt ? (
    <Modal open={when} onClose={handleCancel}>
      <Box style={customStyles}>
        <div
          className="bg-white px-4 py-3 d-flex flex-column gap-2"
          style={{ borderRadius: 6 }}
        >
          <div className="d-flex justify-content-between align-items-center">
            <p className="mb-0 card-title">¿Desea guardar los cambios?</p>
            <Button color="" className="shadow-none p-0" onClick={handleCancel}>
              <AiOutlineClose size={16} />
            </Button>
          </div>
          <hr className="my-0 text-gray mt-1" />
          <div className="d-flex flex-column gap-3 mt-3 mb-1">
            <p>
              Tienes cambios sin guardar que se perderán si eliges no hacerlo.
              Guarda los cambios para no perder tu trabajo.
            </p>
          </div>
          <div className="d-flex justify-content-end gap-2 mt-2">
            <Button
              onClick={e => handleSave(e, false)}
              color="light"
              className="shadow-none"
            >
              No guardar
            </Button>
            <Button
              onClick={e => {
                if (history.location.pathname.includes("/balance")) {
                  userStore.setState({ modalSave: true })
                }
                handleSave(e, true)
              }}
              color="primary"
              type="submit"
              className="ms-auto shadow-none"
            >
              Guardar
            </Button>
            <Button
              color="light"
              onClick={handleCancel}
              className="shadow-none"
            >
              Cancelar
            </Button>
          </div>
        </div>
      </Box>
    </Modal>
  ) : null
}

export default RouterPrompt
